import * as React from 'react';
import { styled } from '@glitz/react';
import Image from 'webapp/components/image';
import { createMaxMobileViewportDecorator } from 'webapp/viewport';
import { useMatchMobile } from '@avensia/excite';
import { addSelectContentEventToDataLayer } from 'webapp/tracking/events/content';
import Link from 'webapp/components/Link';

export const ArticleCard = React.memo(
  (props: NordicNest.Api.ArticleListItemApiModel & { backgroundColor?: string; useImageWrapper?: boolean }) => {
    const isMobile = useMatchMobile();

    const image = props.useImageWrapper ? (
      <ImageWrapper>
        <WideArticleImage image={isMobile ? props.image : props.wideImage} preset={'tiny'} />
      </ImageWrapper>
    ) : (
      <ArticleImage image={props.image} preset={'tiny'} />
    );

    return (
      <CardBase>
        <BaseLink
          to={props.url}
          onClick={() => addSelectContentEventToDataLayer({ id: props.id, type: 'article', link: props.url })}
        >
          {image}
          <Category>{props.category}</Category>
          <Text>
            <Title>{props.title}</Title>
          </Text>
          <Date>{props.date}</Date>
        </BaseLink>
      </CardBase>
    );
  },
);

const Category = styled.div({
  paddingTop: t => t.sharedSpacing.m,
  textTransform: 'uppercase',
  fontSize: t => t.sharedFontSize.xxs,
});

const CardBase = styled.div({
  display: 'block',
  backgroundColor: 'white',
  position: 'relative',
  height: '100%',
});

const BaseLink = styled(Link, {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const ImageWrapper = styled.div(
  createMaxMobileViewportDecorator({
    paddingTop: '76.991%',
  }),
  {
    paddingTop: '50%',
    position: 'relative',
  },
);

const ArticleImage = styled(Image, {
  width: '100%',
});

const WideArticleImage = styled(ArticleImage, {
  position: 'absolute',
  height: '100%',
  objectFit: 'cover',
  top: 0,
});

const Text = styled.div({
  padding: { y: t => t.sharedSpacing.m },
  flexGrow: 1,
});

const Date = styled.div({
  fontSize: t => t.fontSize.xxs,
  marginBottom: t => t.sharedSpacing.s,
});

const Title = styled.h5({
  fontSize: t => t.sharedFontSize.m,
  fontWeight: t => t.fontWeight?.bold,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});
